export function postMessageExitLearnApp() {
  window.parent.postMessage({ messageType: 'exit-learn-app', data: {} }, '*');
}

export function postMessageEndSession() {
  window.parent.postMessage({ messageType: 'end-session', data: {} }, '*');
}
